module.exports = __webpack_public_path__ + "static/media/dr1.9802d6ef.svg";